{
  "name": "@apps/web",
  "version": "0.1.0",
  "private": true,
  "engines": {
    "node": "=24",
    "pnpm": "=10"
  },
  "dependencies": {
    "@angular-slider/ngx-slider": "22.0.0",
    "@angular/animations": "22.1.6",
    "@angular/cdk": "22.1.6",
    "@angular/forms": "22.1.6",
    "@angular/google-maps": "22.1.6",
    "@angular/material": "22.1.6",
    "@angular/platform-browser-dynamic": "22.1.6",
    "@angular/platform-server": "22.1.6",
    "@angular/router": "22.1.6",
    "@angular/service-worker": "22.1.6",
    "@arcgis/core": "4.30.9",
    "@arcgis/map-components": "4.30.7",
    "@becksdevteam/angular-common": "22.1.6",
    "@becksdevteam/font-awesome": "6.7.1",
    "@becksdevteam/rollbar-angular": "22.1.6",
    "@flagsmith/flagsmith": "11.0.0",
    "@fortawesome/angular-fontawesome": "5.1.0",
    "@fortawesome/fontawesome-common-types": "7.3.1",
    "@fortawesome/fontawesome-svg-core": "7.3.1",
    "@googlemaps/js-api-loader": "1.16.10",
    "@maskito/angular": "3.11.1",
    "@maskito/core": "3.11.1",
    "@maskito/kit": "3.11.1",
    "@ngrx/component-store": "22.0.1",
    "@ngrx/effects": "22.0.1",
    "@ngrx/entity": "22.0.1",
    "@ngrx/operators": "22.0.1",
    "@ngrx/router-store": "22.0.1",
    "@ngrx/signals": "22.0.1",
    "@ngrx/store": "22.0.1",
    "@ngrx/store-devtools": "22.0.1",
    "@okta/okta-auth-js": "8.0.1",
    "@perfectmemory/ngx-contextmenu": "22.0.0",
    "angular-calendar": "0.31.0",
    "angular-draggable-droppable": "8.0.0",
    "angular-resizable-element": "7.0.2",
    "angulartics2": "14.1.0",
    "buttercms": "3.0.3",
    "calendar-utils": "0.10.4",
    "date-fns": "4.4.0",
    "date-fns-tz": "3.2.0",
    "file-saver": "2.0.5",
    "he": "1.2.0",
    "highcharts": "12.6.0",
    "highcharts-angular": "5.4.1",
    "moment-timezone": "0.6.3",
    "ng-inline-svg-2": "20.0.2",
    "ngx-cookie-service": "22.0.0",
    "ngx-extended-pdf-viewer": "30.0.0",
    "ngx-mat-select-search": "9.0.0",
    "signature_pad": "5.1.4",
    "socket.io-client": "4.8.3",
    "uuid": "14.0.2"
  },
  "devDependencies": {
    "@angular-devkit/architect": "0.2201.8",
    "@angular-devkit/core": "22.1.8",
    "@angular-devkit/schematics": "22.1.8",
    "@angular/cli": "22.1.8",
    "@angular/language-service": "22.1.6",
    "@angular/pwa": "22.1.8",
    "@ngneat/spectator": "22.1.0",
    "@ngrx/schematics": "22.0.1",
    "@schematics/angular": "22.1.8",
    "@standard-schema/spec": "1.1.0",
    "@types/file-saver": "2.0.7",
    "@types/google.maps": "3.66.2",
    "autoprefixer": "10.5.5",
    "tailwindcss": "3.4.19"
  }
}
